import ExportSidebar from "./ProSideBar";
import { PageHeader } from "./AuxiliaryFunctions";
import { useSelector, useDispatch } from "react-redux";
import UserDataService from "./services/user.serviceaux";
import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import './index.css';
import { IoMdBuild } from "react-icons/io";
import { Col, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { logout } from "./actions/auth.js";

const Dashboard = () => {
  const { user: currentUser } = useSelector((state) => state.auth);	
  const [status, setStatus] = useState("");
  const [primernombre, setPrimernombre] = useState("");
  const [primerapellido, setprimerapellido] = useState("");
  const [arean1, setarean1] = useState(null);
  const [arean2, setarean2] = useState(null);
  const [banco, setbanco] = useState("");
  const [clabe, setclabe] = useState("");
  const [bio, setbio] = useState("");
  const [salariodiarioesperado, setsalariodiarioesperado] = useState(null);
    
  const dispatch = useDispatch();

  useEffect(() => {
    
    UserDataService.get(currentUser.id)
    .then(
      (response) => { 
        console.log(response.data);
        console.log(currentUser);        
        if (response.data.length > 0) {
          setPrimernombre(response.data[0].primernombre);
          setprimerapellido(response.data[0].primerapellido);
          setStatus(response.data[0].habilitado);
        }
        else {
          dispatch(logout());
        }
      }
    )
    .catch((e) => {
      if (e.response.status == 401) {
        console.log("status 401 or 403");
        dispatch(logout())
        .then(() => {
          window.location.reload();
          //window.location.assign('/login');
        })
        .catch((error) => {
          console.error(error);
        });
      }
      console.log(e.response);
    });
    
    
  }, []);
  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
      <div style={{display:'block',width:'100%'}}>
        <PageHeader />        
        <div className="main-frame-page">
          <h5 style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>{"Bienvenido " + primernombre + " " + primerapellido}</h5>
          < hr/>
          {(status === 1) && 
            <>
            <div className="customCard">
              <p>Mis competencias</p>
              < hr/>              
              <Container className="d-flex">
                <Col>
                  <p>Ve las competencias en las cuales has sido asignado(a).</p>
                  <td>            
                    <Button className="btn btn-secondary">
                      <Link to = {`/listofcompetenciasusuario/${currentUser.id}`} style={{color:'white',textDecoration:'none'}}>
                        {"Ver mis competencias"}
                      </Link>
                    </Button>
                  </td>                
                </Col>
              </Container>
              
            </div>

            <div className="customCard">
              <p>Mi perfil</p>
              < hr/>              
              <Container className="d-flex">
                <Col>
                  {(arean1 == null || arean2 == null || banco == "" || clabe == "" || bio == "" || salariodiarioesperado == null) && 
                    <>
                    <p>Tu perfil todavía no está completo al 100%.</p>
                    <Button variant='secondary'>
                      <Link to = {`/userprofile`} style={{color:'white',textDecoration:'none'}}>{"Actualizar mi perfil"}</Link>      
                    </Button>
                    </>
                  }

                </Col>
              </Container>
              
            </div>
            </>
          }
          {(status === 0) && 
            <>
            <h5>Tu perfil aun no ha sido habilitado por un administrador.</h5>
            <div style={{backgroundColor:'', padding:'10px'}}>
              Cuando tu perfil esté habilitado tendrás acceso a más opciones en la plataforma!
            </div>
            </>
          }          
        </div>

      </div>
      
    </div>
    </>
  )

};
  
export default Dashboard;